import React from 'react';
import { classNames, key } from '@philips-internal/oswald-ui-utils';
import { getWeekDays } from '../date-picker-util.js';
function DatePickerAcronyms({ currentDay }) {
    const acronyms = getWeekDays(true).map((weekday) => weekday[0]);
    const currentWeekday = currentDay ? currentDay.weekday() : -1;
    return (React.createElement("ul", { className: "c-date-picker__acronyms" }, acronyms.map((acronym, index) => {
        const className = classNames({
            'c-date-picker__item': true,
            'c-date-picker__item-current-weekday': index === currentWeekday,
        });
        return (React.createElement("li", { className: className, key: key('c-date-picker-acronym') }, acronym));
    })));
}
export { DatePickerAcronyms, };
//# sourceMappingURL=date-picker-acronyms.js.map